/** Rola até uma seção dos guias de procedimento (âncora = id da Section). */
export const scrollToGuideSection = (id: string): void => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
